export const createSingleUnitMutation = /* GraphQL */ `
    mutation CreateSingleUnit($input: CreateSingleUnitInput!) {
        createSingleUnit(input: $input) {
            id
            categoryId
            name
            description
            image
            inputDate
            inputByPerson
            unitOfMeasure
            locationId
            dailyServiceLogFormId
            equipmentStatus
            createdAt
            updatedAt
        }
    }
`;
